import React from 'react';

import HomePage from './HomePage';

const DistrictPage = (props) => (
  <HomePage context={props.pageContext} isHome location={props.location} />
);

export default DistrictPage;
